import styled from 'styled-components';
import devices from '#app/interface/devices';
import { Row } from '#app/pages/styles';

export const ContainerIconWrapper = styled.div`
  position: relative !important;
  width: auto !important;
`;
export const Container = styled.div`
  //position: relative;

  @media ${devices.mobileL} {
    margin-right: 3px;
    margin-left: 3px;
  }
  @media ${devices.tablet} {
    margin-right: 3px;
    margin-left: 3px;
  }
  @media ${devices.laptop} {
    margin-right: 5px;
    margin-left: 5px;
  }

  a {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: right;
    color: #4378ff;
    padding: 11px 24px;
    border-radius: 8px;
  }

  a.active {
    color: #000000;
  }

  a:hover {
    background-color: #eff2f5;
  }
`;

export const Img = styled.img`
  width: 15px;
  height: 15px;
  cursor: pointer;

  &.rotated {
    transform: rotate(180deg);
  }
`;
export const Empty = styled.div`
  width: 15px;
  height: 15px;
`;

export const Ticker = styled.div`
  width: 100%;

  & > div {
    color: #000 !important;
    word-break: keep-all;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  & > div > div {
    width: 420px;
    display: flex;
    align-items: center;
  }

  & > div > div > div {
    display: inline-block;
    margin-right: 10px;
  }

  img.icon {
    border-radius: 30px;
    margin-right: 5px;
    width: 24px;
    height: 24px;
  }
`;

export const HeaderMaxWidthContainer = styled.div`
  width: 100%;
`;

export const RowContainer = styled(Row)`
  flex-wrap: nowrap;
  justify-content: space-between;
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  flex: 1;
  min-width: 0;
`;

export const FilterContainer = styled.div`
  flex-shrink: 0;
`;
